import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as React from "react";

import MenuIcon from "@mui/icons-material/Menu";
import { Stack, Tooltip, Typography, Paper } from "@mui/material";
import Box from "@mui/material/Box";
import ViewColumnIcon from "@mui/icons-material/ViewColumn";
import TableRowsIcon from "@mui/icons-material/TableRows";
import Button from "@mui/material/Button";
import {changeContractDrilldownCS} from "../contractDrilldownSliceCS";
import QueryFinancialsDropdownVersion from "./LineItems/QueryFinancialsDropdownVersion";
import QueryFinancialsGridVersionNarrow from "./LineItems/QueryFinancialsGridVersionNarrow";
import QueryFinancialsGridVersionWide from "./LineItems/QueryFinancialsGridVersionWide";
import {changeContractDrilldown} from "../../contractDrilldownSlice";
import ParticipantShareForm from "./Share/ParticipantShareForm";

export default function HelperPanel() {
    const dispatchData = useDispatch();
    //
    // const selectorQfDrawerMode = useSelector(
    //     (state) => state.contractDrilldownSlcCS.value.QfDrawerMode
    // );

    const selectorHelperMode =  useSelector((state) => state.contractDrilldownSlc.value.helperMode);

    const [clearForm, setClearForm] = useState(false);
    //
    // function handleDropdownClick() {
    //     dispatchData(changeContractDrilldownCS({ QfDrawerMode: "Dropdown" }));
    // }
    //
    // function handleGridNarrowClick() {
    //     dispatchData(changeContractDrilldownCS({ QfDrawerMode: "GridNarrow" }));
    // }
    //
    // function handleGridWideClick() {
    //     dispatchData(changeContractDrilldownCS({ QfDrawerMode: "GridWide" }));
    // }

    function handleExit() {
        dispatchData(changeContractDrilldown({helperState: false, dynamicHelperState: false}));
    }

    return (
        <div>
        <Paper
            elevation={3}
            sx={{
                height: 700,
                overflowY: "auto",
                overflowX: "hidden",
                p: 2,
                // pl: 4,
                mt: 4,
                width: 1000,
                boxSizing: "border-box"
            }}
        >
            <Stack direction="row" spacing={2} alignItems="center" sx={{ mb: 2 }}>
            <Typography sx={{ fontSize: 20, fontWeight: "bold" }}>
                {selectorHelperMode} Form
            </Typography>

            {/*<Stack direction="row" spacing={2} alignItems="center" sx={{ mb: 2 }}>*/}
            {/*    <Tooltip enterDelay={1000} title="View as Dropdown lists">*/}
            {/*        <MenuIcon*/}
            {/*            sx={{*/}
            {/*                color:*/}
            {/*                    selectorQfDrawerMode === "Dropdown"*/}
            {/*                        ? "black"*/}
            {/*                        : "primary.main",*/}
            {/*                cursor: "pointer"*/}
            {/*            }}*/}
            {/*            onClick={handleDropdownClick}*/}
            {/*        />*/}
            {/*    </Tooltip>*/}

            {/*    <Tooltip enterDelay={1000} title="View as single-row Grids">*/}
            {/*        <ViewColumnIcon*/}
            {/*            sx={{*/}
            {/*                color:*/}
            {/*                    selectorQfDrawerMode === "GridNarrow"*/}
            {/*                        ? "black"*/}
            {/*                        : "primary.main",*/}
            {/*                cursor: "pointer"*/}
            {/*            }}*/}
            {/*            onClick={handleGridNarrowClick}*/}
            {/*        />*/}
            {/*    </Tooltip>*/}

            {/*    <Tooltip enterDelay={1000} title="View as wide Grids">*/}
            {/*        <TableRowsIcon*/}
            {/*            sx={{*/}
            {/*                color:*/}
            {/*                    selectorQfDrawerMode === "GridWide"*/}
            {/*                        ? "black"*/}
            {/*                        : "primary.main",*/}
            {/*                cursor: "pointer"*/}
            {/*            }}*/}
            {/*            onClick={handleGridWideClick}*/}
            {/*        />*/}
            {/*    </Tooltip>*/}
                <Button
                    type="submit"
                                // type="submit"
                form={
                    selectorHelperMode === "Overall Share"
                        ? "lineItemForm":
                        selectorHelperMode === "Participant Gross Share"
                            ? "lineItemForm":
                            selectorHelperMode === "Participant Net Share"
                                ? "lineItemForm":
                            // ? "ParticipantShareForm"
                        selectorHelperMode === "Adjusted Gross Receipts"
                            ? "lineItemForm":
                            selectorHelperMode === "Gross Receipts"
                                ? "lineItemForm":
                                selectorHelperMode === "Allowed Expenses"
                                    ? "lineItemForm":
                                    selectorHelperMode === "Account: Mapped Dist"
                                        ? "lineItemForm" :
                                        selectorHelperMode === "Account: Mapped Prod"
                                            ? "lineItemForm" :
                                            selectorHelperMode === "Account: Other"
                                                ? "lineItemForm" :
                                                selectorHelperMode === "Account: Residuals"
                                                    ? "lineItemForm" :
                selectorHelperMode === "Line Item"
                ? "lineItemForm" :
                    selectorHelperMode === "Cost Item"
                        ? "lineItemForm" :
                    selectorHelperMode === "Summary Item"
                        ? "lineItemForm" :
                        selectorHelperMode === "Bonus"
                            ? "lineItemForm" :
                        selectorHelperMode === "Distribution Fee"
                            ? "lineItemForm" :
                            selectorHelperMode === "Overhead Fee"
                                ? "lineItemForm" :
                "defaultForm"
                }
                    autoFocus = {true}
                >
                   Submit
                </Button>
                <Button onClick={() => setClearForm(prev => !prev)}>
                    Clear Form
                </Button>
                <Button onClick={() => handleExit(prev => !prev)}>
                    Exit Helper
                </Button>
            </Stack>
            <Box
                sx={{
                    height: 620,
                    overflowY: "auto",
                    p: 2
                }}
            >
            {/*{selectorQfDrawerMode === "Dropdown" && (*/}
            {/*    <QueryFinancialsDropdownVersion clearForm={clearForm} />*/}
            {/*)}*/}

            {/*{selectorQfDrawerMode === "GridNarrow" && (*/}
            {/*    <QueryFinancialsGridVersionNarrow clearForm={clearForm} />*/}
            {/*)}*/}

            {/*{selectorQfDrawerMode === "GridWide" && (*/}
            {selectorHelperMode === "Summary Item" &&
                <QueryFinancialsGridVersionWide
                    clearForm={clearForm}
                    // onSubmit = {onSubmit}
                />}
                {selectorHelperMode === "Account: Mapped Dist" &&
                    <QueryFinancialsGridVersionWide
                        clearForm={clearForm}
                        // onSubmit = {onSubmit}
                    />}
                {selectorHelperMode === "Account: Mapped Prod" &&
                    <QueryFinancialsGridVersionWide
                        clearForm={clearForm}
                        // onSubmit = {onSubmit}
                    />}
                {selectorHelperMode === "Account: Other" &&
                    <QueryFinancialsGridVersionWide
                        clearForm={clearForm}
                        // onSubmit = {onSubmit}
                    />}
                {selectorHelperMode === "Account: Residuals" &&
                    <QueryFinancialsGridVersionWide
                        clearForm={clearForm}
                        // onSubmit = {onSubmit}
                    />}
                {selectorHelperMode === "Line Item" &&
                    <QueryFinancialsGridVersionWide
                        clearForm={clearForm}
                        // onSubmit = {onSubmit}
                    />}
            {selectorHelperMode === "Line Item" &&
                <QueryFinancialsGridVersionWide
                    clearForm={clearForm}
                    // onSubmit = {onSubmit}
                />}
                {selectorHelperMode === "Cost Item" &&
                    <QueryFinancialsGridVersionWide
                        clearForm={clearForm}
                        // onSubmit = {onSubmit}
                    />}
            {selectorHelperMode === "Gross Receipts" &&
                <QueryFinancialsGridVersionWide
                    clearForm={clearForm}
                    // onSubmit = {onSubmit}
                />}
            {selectorHelperMode === "Allowed Expenses" &&
                <QueryFinancialsGridVersionWide
                    clearForm={clearForm}
                    // onSubmit = {onSubmit}
                />}
            {selectorHelperMode === "Adjusted Gross Receipts" &&
                <QueryFinancialsGridVersionWide
                    clearForm={clearForm}
                    // onSubmit = {onSubmit}
                />}
            {selectorHelperMode === "Overall Share" &&
                <QueryFinancialsGridVersionWide
                    clearForm={clearForm}
                    // onSubmit = {onSubmit}
                />}
                {selectorHelperMode === "Bonus" &&
                    <QueryFinancialsGridVersionWide
                        clearForm={clearForm}
                        // onSubmit = {onSubmit}
                    />}
                {selectorHelperMode === "Distribution Fee" &&
                    <QueryFinancialsGridVersionWide
                        clearForm={clearForm}
                        // onSubmit = {onSubmit}
                    />}
                {selectorHelperMode === "Overhead Fee" &&
                    <QueryFinancialsGridVersionWide
                        clearForm={clearForm}
                        // onSubmit = {onSubmit}
                    />}
            {selectorHelperMode === "Participant Gross Share" &&
            <QueryFinancialsGridVersionWide clearForm={clearForm} />
            }
            {selectorHelperMode === "Participant Net Share" &&
                <QueryFinancialsGridVersionWide clearForm={clearForm} />
            }
            {/*)}*/}
            </Box>
        </Paper>
        </div>
    );
}